import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/lib/analytics';

/**
 * BrowserRouter라 라우트 전환에도 페이지가 새로 로드되지 않으므로, 경로가 바뀔 때마다 GA4에
 * page_view를 보낸다. document.title은 react-helmet-async가 같은 커밋의 effect에서 비동기로
 * 갱신하므로, setTimeout으로 한 틱 미뤄 갱신된 제목을 읽는다.
 */
export function usePageViewTracking(): void {
  const { pathname, search } = useLocation();

  useEffect(() => {
    const timerId = setTimeout(() => trackPageView(pathname + search), 0);
    return () => clearTimeout(timerId);
  }, [pathname, search]);
}
